export enum OpenButton {
    Lights,
    QuickSettings,
    SpeakerTalkDown,
    Presets,
    QuickDownload,
    Sounds,
    None,
}

export enum CenterAnimation {
    Up,
    Down,
    Left,
    Right,
    ZoomIn,
    ZoomOut,
    Home
}
